// @flow
// import React from 'react';
import {Home} from 'app/pages/Home';
import {Category} from 'app/pages/Category';
import {Author} from 'app/pages/Author';
import {Single} from 'app/pages/Single';
import {NotFound} from 'app/pages/NotFound';
// import {MainLayout} from 'layouts';

const routes = [
  {
    permission: 'UI::PUBLIC::HOME',
    // layout: MainLayout,
    exact: true,
    path: '/',
    page: Home
  },
  {
    permission: 'UI::PUBLIC::CATEGORY',
    // layout: MainLayout,
    exact: true,
    path: '/category/:category',
    page: Category
  },
  {
    permission: 'UI::PUBLIC::CATEGORY',
    path: '/category/:category/page/:page',
    page: Category
  },
  {
    permission: 'UI::PUBLIC::AUTHOR',
    path: '/author/:author/page/:page',
    page: Author
  },
  {
    permission: 'UI::PUBLIC::AUTHOR',
    path: '/author/:author',
    page: Author
  },
  {
    path: '/404',
    page: NotFound
  },
  {
    permission: 'UI::PUBLIC::CATEGORY',
    // layout: MainLayout,
    path: '/:slug',
    page: Single
  },
  {
  	page: NotFound
  }
];

 export default routes;
//  export const redirects = {
//  	'/test': '/fails'
//  };